import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface AppSettings {
  hideTokensDisplay: boolean;
  forceDefaultModel: boolean;
  defaultModelId: string;
  gtmId: string | null;
  gtmEnabled: boolean;
}

export const useAppSettings = () => {
  return useQuery({
    queryKey: ['app-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('site_settings')
        .select('hide_tokens_display, force_default_model, default_model_id, gtm_id, gtm_enabled')
        .single();
      
      if (error) throw error;
      
      return {
        hideTokensDisplay: data?.hide_tokens_display ?? false,
        forceDefaultModel: data?.force_default_model ?? false,
        defaultModelId: data?.default_model_id ?? 'google/gemini-2.5-flash-lite',
        gtmId: data?.gtm_id ?? null,
        gtmEnabled: data?.gtm_enabled ?? false,
      } as AppSettings;
    },
    staleTime: 5 * 60 * 1000, // Cache por 5 minutos
  });
};
